import {DataResponse} from "../../Cirrus/tlDataServices/DataResponse";
import * as angular from 'angular';
import {AuthenticationService} from "./AuthenticationService";
import {NavigationService} from "./NavigationService";

export class LogoutService {
  static serviceId = 'LogoutService';
  static $inject = [
    AuthenticationService.serviceId,
    NavigationService.serviceId,
  ];

  constructor(private auth: AuthenticationService,
              private nav: NavigationService) {

  }

  catchLogoutResponse<T>(promise: angular.IPromise<DataResponse<T>>): angular.IPromise<DataResponse<T>> {
    return promise.then(res => {
      console.log(res.httpReponse.status);
      if (res.httpReponse.status === 401) {
        this.auth.logout().then(() => {
          console.log('logout');
          this.nav.goToState('login');
        });
      }
      return res;
    });
  }
}